import {
  LOGIN_PORTAL_DEFAULT_TEMPLATE,
  isValidPortalTemplateId
} from '../theme/loginPortalThemes';

/** Fired in-tab when the shared page atmosphere template changes. */
export const SHARED_PAGE_ATMOSPHERE_EVENT = 'erp4c-shared-page-atmosphere';

const PORTAL_KEY = 'erp4c_public_portal_template';
const LANDING_KEY = 'erp4c_landing_page_template';
const LOGIN_KEY = 'loginTheme';

/**
 * One page-atmosphere template shared by Landing, Browsing (/query), Sign In, and Register.
 * Reads the first valid value among the synced storage keys.
 */
export function getSharedPageAtmosphere() {
  try {
    for (const key of [PORTAL_KEY, LANDING_KEY, LOGIN_KEY]) {
      const v = localStorage.getItem(key);
      if (isValidPortalTemplateId(v)) return v;
    }
  } catch {
    /* ignore */
  }
  return LOGIN_PORTAL_DEFAULT_TEMPLATE;
}

/**
 * Persist the same page atmosphere for Landing, Browsing, Sign In, and Register.
 */
export function setSharedPageAtmosphere(id) {
  const v = isValidPortalTemplateId(id) ? id : LOGIN_PORTAL_DEFAULT_TEMPLATE;
  try {
    localStorage.setItem(PORTAL_KEY, v);
    localStorage.setItem(LANDING_KEY, v);
    localStorage.setItem(LOGIN_KEY, v);
  } catch {
    /* ignore */
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(
      new CustomEvent(SHARED_PAGE_ATMOSPHERE_EVENT, { detail: { templateId: v } })
    );
  }
  return v;
}

/** Subscribe to shared atmosphere changes (same tab + other tabs via storage). */
export function subscribeSharedPageAtmosphere(handler) {
  if (typeof window === 'undefined') return () => {};

  const onCustom = (e) => {
    const id = e?.detail?.templateId;
    handler(isValidPortalTemplateId(id) ? id : getSharedPageAtmosphere());
  };
  const onStorage = (e) => {
    if (!e.key || ![PORTAL_KEY, LANDING_KEY, LOGIN_KEY].includes(e.key)) return;
    handler(getSharedPageAtmosphere());
  };

  window.addEventListener(SHARED_PAGE_ATMOSPHERE_EVENT, onCustom);
  window.addEventListener('storage', onStorage);
  return () => {
    window.removeEventListener(SHARED_PAGE_ATMOSPHERE_EVENT, onCustom);
    window.removeEventListener('storage', onStorage);
  };
}
